import './set-api.js'
import 'core-js/stable'
import { createApp } from 'vue'
import { createBootstrap } from 'bootstrap-vue-next'
import * as BVN from 'bootstrap-vue-next'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Axios from 'axios'
import { publishAiTokenUsage } from './lib/ai-token-usage.js'
import { designerTabId } from './lib/designer-sync.js'
import ModalHelp from './components/ModalHelp.vue'
import { browserTimeZone } from '../../shared/app-timezone'

library.add(fas)

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import './css/designer-controls.css'

import VueCookies from 'vue-cookies'

Axios.defaults.withCredentials = true

function designerApplication () {

  const route = router.currentRoute && router.currentRoute.value

  return route && route.params && route.params.application
}

function isDesignerApiUrl (url) {

  const api = window.__SUPERTURBO_API__ || ''

  return Boolean(api && url && String(url).startsWith(api))
}

Axios.interceptors.request.use((config) => {

  config.headers = config.headers || {}

  if (typeof config.headers.set === 'function') {

    config.headers.set('x-viewer-time-zone', browserTimeZone())
    config.headers.set('x-designer-tab', designerTabId())
  } else {

    config.headers['x-viewer-time-zone'] = browserTimeZone()
    config.headers['x-designer-tab'] = designerTabId()
  }

  const application = designerApplication()

  if (!application || !isDesignerApiUrl(config.url)) return config

  config.headers = config.headers || {}

  if (typeof config.headers.set === 'function') {

    config.headers.set('application-unique-title', application)
  } else {

    config.headers['application-unique-title'] = application
  }

  return config
})

Axios.interceptors.response.use((response) => {

  const usage = response && response.data && response.data.tokenUsage

  if (usage) publishAiTokenUsage(usage)

  return response
})

const nativeFetch = window.fetch.bind(window)

window.fetch = (input, init = {}) => {

  const application = designerApplication()
  const url = typeof input === 'string' ? input : (input && input.url)

  if (!application || !isDesignerApiUrl(url)) return nativeFetch(input, init)

  const headers = new Headers(init.headers || (typeof Request !== 'undefined' && input instanceof Request ? input.headers : undefined))

  headers.set('application-unique-title', application)
  headers.set('x-designer-tab', designerTabId())

  return nativeFetch(input, { ...init, headers })
}

// Suppress benign ResizeObserver loop errors triggered by floating UI (popover positioning)
window.addEventListener('error', (e) => {
  if (e.message && (
    e.message.includes('ResizeObserver loop completed') ||
    e.message.includes('ResizeObserver loop limit exceeded')
  )) {
    e.stopImmediatePropagation()
    e.preventDefault()
  }
})

const app = createApp(App)
app.use(router)
app.use(createBootstrap())
app.use(createPinia())
app.use(VueCookies)
VueCookies.config('7d')

// Register all bootstrap-vue-next components globally
// createBootstrap() only installs plugins (modal controller, toast, etc.)
// but does not register components in v0.24.x
const componentPrefix = /^B[A-Z]/
for (const [name, component] of Object.entries(BVN)) {
  if (componentPrefix.test(name) && typeof component === 'object' && component.setup) {
    app.component(name, component)
  }
}

app.config.globalProperties.$http = Axios
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('modal-help', ModalHelp)

app.mount('#app')
